"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _Skeleton = _interopRequireDefault(require("../../Skeleton"));

var _Typography = _interopRequireDefault(require("../../Typography"));

var _useIsLoading = _interopRequireDefault(require("../LoadingProvider/useIsLoading"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  return {
    root: {
      ':first-letter': {
        textTransform: 'capitalize'
      }
    }
  };
};

var UpdateDate = function UpdateDate(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'white' : _props$color,
      date = props.date,
      other = (0, _objectWithoutProperties2["default"])(props, ["color", "date"]);
  var classes = useStyles();
  var isLoading = (0, _useIsLoading["default"])();
  var formattedDate = (0, _react.useMemo)(function () {
    var momentDate = (0, _moment["default"])(date);

    if (typeof date === 'undefined' || !momentDate.isValid()) {
      return '';
    }

    return momentDate.fromNow();
  }, [date]);
  return (0, _core.jsx)(_Typography["default"], (0, _extends2["default"])({
    "data-testid": "UpdateDate",
    css: classes.root,
    variant: "tertiaryDefault",
    color: color
  }, other), isLoading ? (0, _core.jsx)(_Skeleton["default"], {
    color: color,
    width: "30%"
  }) : formattedDate);
};

__signature__(UpdateDate, "useStyles{classes}\nuseIsLoading{isLoading}\nuseMemo{formattedDate}", function () {
  return [useStyles, _useIsLoading["default"]];
});

var _default = UpdateDate;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Header/UpdateDate.tsx");
  reactHotLoader.register(UpdateDate, "UpdateDate", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Header/UpdateDate.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Header/UpdateDate.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();